module.exports = __webpack_public_path__ + "static/img/1.749d45a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/1.png
// module id = 6WYv
// module chunks = 0